// extracted by mini-css-extract-plugin
module.exports = {"card":"Board_card__PybYc"};